<template>
  <q-select outlined :modelValue="modelValue" :label="label" @update:modelValue="$emit('update:modelValue', $event)"
    use-input hide-selected fill-input :options="options" :error="error" :loading="loading" emit-value map-options
    option-value="DA0_CODTAB" option-label="DA0_DESCRI">
    <template v-slot:option="scope">
      <q-item v-bind="scope.itemProps">
        <q-item-section>
          <q-item-label>{{ scope.opt.DA0_DESCRI }}</q-item-label>
          <q-item-label caption>{{ scope.opt.DA0_CODTAB }}</q-item-label>
        </q-item-section>
      </q-item>
    </template>
    <template v-slot:no-option>
      <q-item>
        <q-item-section class="text-grey">
          No results
        </q-item-section>
      </q-item>
    </template>
    <template v-slot:error>
      <span v-for="err in errors" :key="err">{{ err }}</span>
    </template>
  </q-select>
</template>

<script setup>
import { computed, ref, onMounted } from 'vue'
import PrecioListaService from '@/services/PrecioListaService';

const props = defineProps({
  modelValue: [String, Number, Object],
  errors: [String, Array],
  label: [String]
});
defineEmits(['update:modelValue']);
const options = ref([]);
const error = computed(() => props?.errors && props?.errors?.length !== 0)
const loading = ref(false)
onMounted(async () => {
  loading.value = true;
  options.value = await PrecioListaService.getAll()
  loading.value = false;
})

</script>
